/*
 * @Author: AI Assistant
 * @Date: 2026-01-06
 * @Description: 音乐工具组件多语言配置
 * @FilePath: /weryai-web/locales/modules/music.ts
 */
export default {
    zh: {
        // 音乐工具组件翻译
        vocalSong: '人声歌曲',
        instrumental: '纯音乐',
        creativeDescription: '创意描述',
        creativeDescriptionPlaceholder: '请描述您想要的音乐风格、情感或场景，例如：轻松愉快的流行音乐，适合在咖啡厅播放',
        styleCategory: '曲风',
        moodCategory: '情感',
        instCategory: '乐器',
        lyricsContent: '歌词内容',
        lyricsPlaceholder: '在这里写下你的歌词，可以使用 [Verse]、[Chorus] 等标记...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: '输入歌词...',
        aiGenerate: 'AI生成',
        voiceSelect: '声线选择',
        selectVoice: '选择声线',
        voiceTimbre: '音色',
        maleVoice: '男声',
        femaleVoice: '女声',
        referenceAudioLabel: '参考音频',
        clickToUploadAudio: '点击上传参考音频 (最长5分钟)',
        uploading: '上传中...',
        uploaded: '已上传',
        pleaseUploadAudioFile: '请上传音频文件',
        audioDurationLimit: '音频时长不能超过 5 分钟',
        cannotReadAudioInfo: '无法读取音频信息，请检查文件格式',
        audioUploadSuccess: '音频上传成功',
        audioUploadFailed: '音频上传失败',
        pleaseEnterPrompt: '请输入创意描述或歌词',
        createSuccess: '创作任务已提交',
        createFailed: '创作失败，请重试',
        // MV 页面
        mvDescription: '为你的音乐创建炫酷的AI视觉效果',
        musicSource: '音乐来源',
        uploadMusic: '点击上传音乐文件',
        visualStyle: '视觉风格',
        visualPrompt: '视觉描述',
        visualPromptPlaceholder: '描述你想要的视觉效果...',
        resolution: '分辨率',
        mvEmptyState: '准备创建你的MV',
        mvEmptyStateHint: '上传音乐，选择视觉风格，开始生成',
    },
    en: {
        // Music tool component translations
        vocalSong: 'Vocal Song',
        instrumental: 'Instrumental',
        creativeDescription: 'Creative Description',
        creativeDescriptionPlaceholder: 'Describe your desired music style, emotion, or scene, e.g., relaxing pop music suitable for playing in a coffee shop',
        styleCategory: 'Style',
        moodCategory: 'Mood',
        instCategory: 'Instruments',
        lyricsContent: 'Lyrics',
        lyricsPlaceholder: 'Write your lyrics here, you can use [Verse], [Chorus] tags...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Enter lyrics...',
        aiGenerate: 'AI Generate',
        voiceSelect: 'Voice Selection',
        selectVoice: 'Select Voice',
        voiceTimbre: 'Voice Timbre',
        maleVoice: 'Male',
        femaleVoice: 'Female',
        referenceAudioLabel: 'Reference Audio',
        clickToUploadAudio: 'Click to upload reference audio (max 5 minutes)',
        uploading: 'Uploading...',
        uploaded: 'Uploaded',
        pleaseUploadAudioFile: 'Please upload an audio file',
        audioDurationLimit: 'Audio duration cannot exceed 5 minutes',
        cannotReadAudioInfo: 'Cannot read audio info, please check file format',
        audioUploadSuccess: 'Audio uploaded successfully',
        audioUploadFailed: 'Audio upload failed',
        pleaseEnterPrompt: 'Please enter a description or lyrics',
        createSuccess: 'Creation task submitted',
        createFailed: 'Creation failed, please try again',
        // MV page
        mvDescription: 'Create stunning AI visuals for your music',
        musicSource: 'Music Source',
        uploadMusic: 'Click to upload music file',
        visualStyle: 'Visual Style',
        visualPrompt: 'Visual Description',
        visualPromptPlaceholder: 'Describe the visual effects you want...',
        resolution: 'Resolution',
        mvEmptyState: 'Ready to create your MV',
        mvEmptyStateHint: 'Upload music, choose visual style, start generating',
    },
    ja: {
        // 音楽ツールコンポーネント翻訳
        vocalSong: 'ボーカル曲',
        instrumental: 'インストゥルメンタル',
        creativeDescription: 'クリエイティブ説明',
        creativeDescriptionPlaceholder: 'お望みの音楽スタイル、感情、シーンを説明してください。例：カフェで流すのに適したリラックスできるポップミュージック',
        styleCategory: 'スタイル',
        moodCategory: 'ムード',
        instCategory: '楽器',
        lyricsContent: '歌詞',
        lyricsPlaceholder: 'ここに歌詞を入力、[Verse]、[Chorus]などのタグが使用可能...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: '歌詞を入力...',
        aiGenerate: 'AI生成',
        voiceSelect: 'ボイス選択',
        selectVoice: 'ボイスを選択',
        voiceTimbre: '声質',
        maleVoice: '男性',
        femaleVoice: '女性',
        referenceAudioLabel: '参照オーディオ',
        clickToUploadAudio: 'クリックして参照オーディオをアップロード（最大5分）',
        uploading: 'アップロード中...',
        uploaded: 'アップロード済み',
        pleaseUploadAudioFile: 'オーディオファイルをアップロードしてください',
        audioDurationLimit: 'オーディオの長さは5分を超えることはできません',
        cannotReadAudioInfo: 'オーディオ情報を読み取れません。ファイル形式を確認してください',
        audioUploadSuccess: 'オーディオのアップロードに成功しました',
        audioUploadFailed: 'オーディオのアップロードに失敗しました',
        pleaseEnterPrompt: '説明または歌詞を入力してください',
        createSuccess: '作成タスクが送信されました',
        createFailed: '作成に失敗しました。もう一度お試しください',
        // MVページ
        mvDescription: '音楽のための素晴らしいAIビジュアルを作成',
        musicSource: '音楽ソース',
        uploadMusic: 'クリックして音楽ファイルをアップロード',
        visualStyle: 'ビジュアルスタイル',
        visualPrompt: 'ビジュアル説明',
        visualPromptPlaceholder: '希望のビジュアル効果を説明してください...',
        resolution: '解像度',
        mvEmptyState: 'MVを作成する準備ができました',
        mvEmptyStateHint: '音楽をアップロードし、ビジュアルスタイルを選択して生成開始',
    },
    ko: {
        // 음악 도구 구성 요소 번역
        vocalSong: '보컬 노래',
        instrumental: '인스트루멘탈',
        creativeDescription: '창작 설명',
        creativeDescriptionPlaceholder: '원하는 음악 스타일, 감정 또는 장면을 설명하세요. 예: 카페에서 틀기 좋은 편안한 팝 음악',
        styleCategory: '스타일',
        moodCategory: '분위기',
        instCategory: '악기',
        lyricsContent: '가사',
        lyricsPlaceholder: '가사를 입력하세요. [Verse], [Chorus] 태그 사용 가능...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: '가사 입력...',
        aiGenerate: 'AI 생성',
        voiceSelect: '보이스 선택',
        selectVoice: '보이스 선택',
        voiceTimbre: '음색',
        maleVoice: '남성',
        femaleVoice: '여성',
        referenceAudioLabel: '참조 오디오',
        clickToUploadAudio: '클릭하여 참조 오디오 업로드 (최대 5분)',
        uploading: '업로드 중...',
        uploaded: '업로드됨',
        pleaseUploadAudioFile: '오디오 파일을 업로드하세요',
        audioDurationLimit: '오디오 길이는 5분을 초과할 수 없습니다',
        cannotReadAudioInfo: '오디오 정보를 읽을 수 없습니다. 파일 형식을 확인하세요',
        audioUploadSuccess: '오디오 업로드 성공',
        audioUploadFailed: '오디오 업로드 실패',
        pleaseEnterPrompt: '설명 또는 가사를 입력하세요',
        createSuccess: '생성 작업이 제출되었습니다',
        createFailed: '생성 실패, 다시 시도해주세요',
        // MV 페이지
        mvDescription: '음악을 위한 멋진 AI 비주얼 만들기',
        musicSource: '음악 소스',
        uploadMusic: '클릭하여 음악 파일 업로드',
        visualStyle: '비주얼 스타일',
        visualPrompt: '비주얼 설명',
        visualPromptPlaceholder: '원하는 시각적 효과를 설명하세요...',
        resolution: '해상도',
        mvEmptyState: 'MV 만들 준비 완료',
        mvEmptyStateHint: '음악 업로드, 비주얼 스타일 선택 후 생성 시작',
    },
    tw: {

        // 音乐工具组件翻译
        vocalSong: '人声歌曲',
        instrumental: '纯音乐',
        creativeDescription: '创意描述',
        creativeDescriptionPlaceholder: '请描述您想要的音乐风格、情感或场景，例如：轻松愉快的流行音乐，适合在咖啡厅播放',
        styleCategory: '曲风',
        moodCategory: '情感',
        instCategory: '乐器',
        lyricsContent: '歌词内容',
        lyricsPlaceholder: '在这里写下你的歌词，可以使用 [Verse]、[Chorus] 等标记...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: '输入歌词...',
        aiGenerate: 'AI生成',
        voiceSelect: '声线选择',
        selectVoice: '选择声线',
        voiceTimbre: '音色',
        maleVoice: '男声',
        femaleVoice: '女声',
        referenceAudioLabel: '参考音频',
        clickToUploadAudio: '点击上传参考音频 (最长5分钟)',
        uploading: '上传中...',
        uploaded: '已上传',
        pleaseUploadAudioFile: '请上传音频文件',
        audioDurationLimit: '音频时长不能超过 5 分钟',
        cannotReadAudioInfo: '无法读取音频信息，请检查文件格式',
        audioUploadSuccess: '音频上传成功',
        audioUploadFailed: '音频上传失败',
        pleaseEnterPrompt: '请输入创意描述或歌词',
        createSuccess: '创作任务已提交',
        createFailed: '创作失败，请重试',
        // MV 页面
        mvDescription: '为你的音乐创建炫酷的AI视觉效果',
        musicSource: '音乐来源',
        uploadMusic: '点击上传音乐文件',
        visualStyle: '视觉风格',
        visualPrompt: '视觉描述',
        visualPromptPlaceholder: '描述你想要的视觉效果...',
        resolution: '分辨率',
        mvEmptyState: '准备创建你的MV',
        mvEmptyStateHint: '上传音乐，选择视觉风格，开始生成',
    },
    pl: {

        // Music tool component translations
        vocalSong: 'Vocal Song',
        instrumental: 'Instrumental',
        creativeDescription: 'Creative Description',
        creativeDescriptionPlaceholder: 'Describe your desired music style, emotion, or scene, e.g., relaxing pop music suitable for playing in a coffee shop',
        styleCategory: 'Style',
        moodCategory: 'Mood',
        instCategory: 'Instruments',
        lyricsContent: 'Lyrics',
        lyricsPlaceholder: 'Write your lyrics here, you can use [Verse], [Chorus] tags...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Enter lyrics...',
        aiGenerate: 'AI Generate',
        voiceSelect: 'Voice Selection',
        selectVoice: 'Select Voice',
        voiceTimbre: 'Voice Timbre',
        maleVoice: 'Male',
        femaleVoice: 'Female',
        referenceAudioLabel: 'Reference Audio',
        clickToUploadAudio: 'Click to upload reference audio (max 5 minutes)',
        uploading: 'Uploading...',
        uploaded: 'Uploaded',
        pleaseUploadAudioFile: 'Please upload an audio file',
        audioDurationLimit: 'Audio duration cannot exceed 5 minutes',
        cannotReadAudioInfo: 'Cannot read audio info, please check file format',
        audioUploadSuccess: 'Audio uploaded successfully',
        audioUploadFailed: 'Audio upload failed',
        pleaseEnterPrompt: 'Please enter a description or lyrics',
        createSuccess: 'Creation task submitted',
        createFailed: 'Creation failed, please try again',
        // MV page
        mvDescription: 'Create stunning AI visuals for your music',
        musicSource: 'Music Source',
        uploadMusic: 'Click to upload music file',
        visualStyle: 'Visual Style',
        visualPrompt: 'Visual Description',
        visualPromptPlaceholder: 'Describe the visual effects you want...',
        resolution: 'Resolution',
        mvEmptyState: 'Ready to create your MV',
        mvEmptyStateHint: 'Upload music, choose visual style, start generating',
    },
    es: {
        // Traducciones de componentes de herramientas musicales
        vocalSong: 'Canción Vocal',
        instrumental: 'Instrumental',
        creativeDescription: 'Descripción Creativa',
        creativeDescriptionPlaceholder: 'Describe el estilo de música, emoción o escena que deseas, por ejemplo: música pop relajante adecuada para reproducir en una cafetería',
        styleCategory: 'Estilo',
        moodCategory: 'Estado de Ánimo',
        instCategory: 'Instrumentos',
        lyricsContent: 'Letra',
        lyricsPlaceholder: 'Escribe tu letra aquí, puedes usar etiquetas [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Ingresa la letra...',
        aiGenerate: 'Generar con IA',
        voiceSelect: 'Selección de Voz',
        selectVoice: 'Seleccionar Voz',
        voiceTimbre: 'Timbre de Voz',
        maleVoice: 'Masculino',
        femaleVoice: 'Femenino',
        referenceAudioLabel: 'Audio de Referencia',
        clickToUploadAudio: 'Haz clic para subir audio de referencia (máximo 5 minutos)',
        uploading: 'Subiendo...',
        uploaded: 'Subido',
        pleaseUploadAudioFile: 'Por favor sube un archivo de audio',
        audioDurationLimit: 'La duración del audio no puede exceder los 5 minutos',
        cannotReadAudioInfo: 'No se puede leer la información del audio, verifica el formato del archivo',
        audioUploadSuccess: 'Audio subido exitosamente',
        audioUploadFailed: 'Error al subir el audio',
        pleaseEnterPrompt: 'Por favor ingresa una descripción o letra',
        createSuccess: 'Tarea de creación enviada',
        createFailed: 'Error en la creación, intenta de nuevo',
        // Página de MV
        mvDescription: 'Crea impresionantes visuales con IA para tu música',
        musicSource: 'Fuente de Música',
        uploadMusic: 'Haz clic para subir archivo de música',
        visualStyle: 'Estilo Visual',
        visualPrompt: 'Descripción Visual',
        visualPromptPlaceholder: 'Describe los efectos visuales que deseas...',
        resolution: 'Resolución',
        mvEmptyState: 'Listo para crear tu MV',
        mvEmptyStateHint: 'Sube música, elige estilo visual, comienza a generar',
    },
    fr: {
        // Traductions des composants d'outils musicaux
        vocalSong: 'Chanson Vocale',
        instrumental: 'Instrumental',
        creativeDescription: 'Description Créative',
        creativeDescriptionPlaceholder: 'Décrivez le style de musique, l\'émotion ou la scène souhaité, par exemple : musique pop relaxante adaptée à un café',
        styleCategory: 'Style',
        moodCategory: 'Ambiance',
        instCategory: 'Instruments',
        lyricsContent: 'Paroles',
        lyricsPlaceholder: 'Écrivez vos paroles ici, vous pouvez utiliser les balises [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Entrez les paroles...',
        aiGenerate: 'Générer avec IA',
        voiceSelect: 'Sélection de Voix',
        selectVoice: 'Sélectionner la Voix',
        voiceTimbre: 'Timbre de Voix',
        maleVoice: 'Masculin',
        femaleVoice: 'Féminin',
        referenceAudioLabel: 'Audio de Référence',
        clickToUploadAudio: 'Cliquez pour télécharger l\'audio de référence (max 5 minutes)',
        uploading: 'Téléchargement...',
        uploaded: 'Téléchargé',
        pleaseUploadAudioFile: 'Veuillez télécharger un fichier audio',
        audioDurationLimit: 'La durée de l\'audio ne peut pas dépasser 5 minutes',
        cannotReadAudioInfo: 'Impossible de lire les informations audio, vérifiez le format du fichier',
        audioUploadSuccess: 'Audio téléchargé avec succès',
        audioUploadFailed: 'Échec du téléchargement audio',
        pleaseEnterPrompt: 'Veuillez entrer une description ou des paroles',
        createSuccess: 'Tâche de création soumise',
        createFailed: 'Échec de la création, veuillez réessayer',
        // Page MV
        mvDescription: 'Créez de superbes visuels IA pour votre musique',
        musicSource: 'Source Musicale',
        uploadMusic: 'Cliquez pour télécharger un fichier musical',
        visualStyle: 'Style Visuel',
        visualPrompt: 'Description Visuelle',
        visualPromptPlaceholder: 'Décrivez les effets visuels que vous souhaitez...',
        resolution: 'Résolution',
        mvEmptyState: 'Prêt à créer votre MV',
        mvEmptyStateHint: 'Téléchargez la musique, choisissez le style visuel, commencez à générer',
    },
    de: {
        // Übersetzungen für Musik-Tool-Komponenten
        vocalSong: 'Gesangslied',
        instrumental: 'Instrumental',
        creativeDescription: 'Kreative Beschreibung',
        creativeDescriptionPlaceholder: 'Beschreiben Sie Ihren gewünschten Musikstil, Emotion oder Szene, z.B.: entspannende Popmusik, die sich für ein Café eignet',
        styleCategory: 'Stil',
        moodCategory: 'Stimmung',
        instCategory: 'Instrumente',
        lyricsContent: 'Liedtext',
        lyricsPlaceholder: 'Schreiben Sie hier Ihren Liedtext, Sie können Tags wie [Verse], [Chorus] verwenden...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Liedtext eingeben...',
        aiGenerate: 'KI-Generierung',
        voiceSelect: 'Stimmauswahl',
        selectVoice: 'Stimme auswählen',
        voiceTimbre: 'Stimmklang',
        maleVoice: 'Männlich',
        femaleVoice: 'Weiblich',
        referenceAudioLabel: 'Referenzaudio',
        clickToUploadAudio: 'Klicken Sie, um Referenzaudio hochzuladen (max. 5 Minuten)',
        uploading: 'Hochladen...',
        uploaded: 'Hochgeladen',
        pleaseUploadAudioFile: 'Bitte laden Sie eine Audiodatei hoch',
        audioDurationLimit: 'Die Audiodauer darf 5 Minuten nicht überschreiten',
        cannotReadAudioInfo: 'Audio-Informationen können nicht gelesen werden, bitte überprüfen Sie das Dateiformat',
        audioUploadSuccess: 'Audio erfolgreich hochgeladen',
        audioUploadFailed: 'Audio-Upload fehlgeschlagen',
        pleaseEnterPrompt: 'Bitte geben Sie eine Beschreibung oder einen Liedtext ein',
        createSuccess: 'Erstellungsaufgabe übermittelt',
        createFailed: 'Erstellung fehlgeschlagen, bitte erneut versuchen',
        // MV-Seite
        mvDescription: 'Erstellen Sie atemberaubende KI-Visuals für Ihre Musik',
        musicSource: 'Musikquelle',
        uploadMusic: 'Klicken Sie, um eine Musikdatei hochzuladen',
        visualStyle: 'Visueller Stil',
        visualPrompt: 'Visuelle Beschreibung',
        visualPromptPlaceholder: 'Beschreiben Sie die gewünschten visuellen Effekte...',
        resolution: 'Auflösung',
        mvEmptyState: 'Bereit, Ihr MV zu erstellen',
        mvEmptyStateHint: 'Musik hochladen, visuellen Stil wählen, Generierung starten',
    },
    ru: {
        // Переводы компонентов музыкальных инструментов
        vocalSong: 'Вокальная Песня',
        instrumental: 'Инструментальная',
        creativeDescription: 'Творческое Описание',
        creativeDescriptionPlaceholder: 'Опишите желаемый стиль музыки, эмоцию или сцену, например: расслабляющая поп-музыка, подходящая для кафе',
        styleCategory: 'Стиль',
        moodCategory: 'Настроение',
        instCategory: 'Инструменты',
        lyricsContent: 'Текст Песни',
        lyricsPlaceholder: 'Напишите здесь текст песни, можно использовать теги [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Введите текст...',
        aiGenerate: 'ИИ Генерация',
        voiceSelect: 'Выбор Голоса',
        selectVoice: 'Выбрать Голос',
        voiceTimbre: 'Тембр Голоса',
        maleVoice: 'Мужской',
        femaleVoice: 'Женский',
        referenceAudioLabel: 'Референсное Аудио',
        clickToUploadAudio: 'Нажмите, чтобы загрузить референсное аудио (макс. 5 минут)',
        uploading: 'Загрузка...',
        uploaded: 'Загружено',
        pleaseUploadAudioFile: 'Пожалуйста, загрузите аудиофайл',
        audioDurationLimit: 'Длительность аудио не может превышать 5 минут',
        cannotReadAudioInfo: 'Не удается прочитать информацию об аудио, проверьте формат файла',
        audioUploadSuccess: 'Аудио успешно загружено',
        audioUploadFailed: 'Ошибка загрузки аудио',
        pleaseEnterPrompt: 'Пожалуйста, введите описание или текст песни',
        createSuccess: 'Задача создания отправлена',
        createFailed: 'Ошибка создания, попробуйте снова',
        // Страница MV
        mvDescription: 'Создавайте потрясающие визуальные эффекты ИИ для вашей музыки',
        musicSource: 'Источник Музыки',
        uploadMusic: 'Нажмите, чтобы загрузить музыкальный файл',
        visualStyle: 'Визуальный Стиль',
        visualPrompt: 'Визуальное Описание',
        visualPromptPlaceholder: 'Опишите желаемые визуальные эффекты...',
        resolution: 'Разрешение',
        mvEmptyState: 'Готовы создать ваш MV',
        mvEmptyStateHint: 'Загрузите музыку, выберите визуальный стиль, начните генерацию',
    },
    pt: {
        // Traduções de componentes de ferramentas musicais
        vocalSong: 'Canção Vocal',
        instrumental: 'Instrumental',
        creativeDescription: 'Descrição Criativa',
        creativeDescriptionPlaceholder: 'Descreva o estilo de música, emoção ou cena desejado, por exemplo: música pop relaxante adequada para tocar em um café',
        styleCategory: 'Estilo',
        moodCategory: 'Humor',
        instCategory: 'Instrumentos',
        lyricsContent: 'Letra',
        lyricsPlaceholder: 'Escreva sua letra aqui, você pode usar tags [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Digite a letra...',
        aiGenerate: 'Gerar com IA',
        voiceSelect: 'Seleção de Voz',
        selectVoice: 'Selecionar Voz',
        voiceTimbre: 'Timbre de Voz',
        maleVoice: 'Masculino',
        femaleVoice: 'Feminino',
        referenceAudioLabel: 'Áudio de Referência',
        clickToUploadAudio: 'Clique para fazer upload do áudio de referência (máx. 5 minutos)',
        uploading: 'Enviando...',
        uploaded: 'Enviado',
        pleaseUploadAudioFile: 'Por favor, faça upload de um arquivo de áudio',
        audioDurationLimit: 'A duração do áudio não pode exceder 5 minutos',
        cannotReadAudioInfo: 'Não é possível ler as informações do áudio, verifique o formato do arquivo',
        audioUploadSuccess: 'Áudio enviado com sucesso',
        audioUploadFailed: 'Falha no envio do áudio',
        pleaseEnterPrompt: 'Por favor, insira uma descrição ou letra',
        createSuccess: 'Tarefa de criação enviada',
        createFailed: 'Falha na criação, tente novamente',
        // Página de MV
        mvDescription: 'Crie visuais incríveis com IA para sua música',
        musicSource: 'Fonte de Música',
        uploadMusic: 'Clique para fazer upload do arquivo de música',
        visualStyle: 'Estilo Visual',
        visualPrompt: 'Descrição Visual',
        visualPromptPlaceholder: 'Descreva os efeitos visuais que você deseja...',
        resolution: 'Resolução',
        mvEmptyState: 'Pronto para criar seu MV',
        mvEmptyStateHint: 'Faça upload da música, escolha o estilo visual, comece a gerar',
    },
    it: {
        // Traduzioni dei componenti degli strumenti musicali
        vocalSong: 'Canzone Vocale',
        instrumental: 'Strumentale',
        creativeDescription: 'Descrizione Creativa',
        creativeDescriptionPlaceholder: 'Descrivi lo stile musicale, l\'emozione o la scena desiderata, ad esempio: musica pop rilassante adatta per un caffè',
        styleCategory: 'Stile',
        moodCategory: 'Umore',
        instCategory: 'Strumenti',
        lyricsContent: 'Testo',
        lyricsPlaceholder: 'Scrivi qui il tuo testo, puoi usare tag [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Inserisci il testo...',
        aiGenerate: 'Genera IA',
        voiceSelect: 'Selezione Voce',
        selectVoice: 'Seleziona Voce',
        voiceTimbre: 'Timbro Vocale',
        maleVoice: 'Maschile',
        femaleVoice: 'Femminile',
        referenceAudioLabel: 'Audio di Riferimento',
        clickToUploadAudio: 'Clicca per caricare l\'audio di riferimento (max 5 minuti)',
        uploading: 'Caricamento...',
        uploaded: 'Caricato',
        pleaseUploadAudioFile: 'Per favore carica un file audio',
        audioDurationLimit: 'La durata dell\'audio non può superare i 5 minuti',
        cannotReadAudioInfo: 'Impossibile leggere le informazioni audio, controlla il formato del file',
        audioUploadSuccess: 'Audio caricato con successo',
        audioUploadFailed: 'Caricamento audio fallito',
        pleaseEnterPrompt: 'Per favore inserisci una descrizione o un testo',
        createSuccess: 'Attività di creazione inviata',
        createFailed: 'Creazione fallita, riprova',
        // Pagina MV
        mvDescription: 'Crea straordinari visual IA per la tua musica',
        musicSource: 'Sorgente Musicale',
        uploadMusic: 'Clicca per caricare il file musicale',
        visualStyle: 'Stile Visivo',
        visualPrompt: 'Descrizione Visiva',
        visualPromptPlaceholder: 'Descrivi gli effetti visivi che desideri...',
        resolution: 'Risoluzione',
        mvEmptyState: 'Pronto per creare il tuo MV',
        mvEmptyStateHint: 'Carica musica, scegli lo stile visivo, inizia a generare',
    },
    ar: {
        // ترجمات مكونات أدوات الموسيقى
        vocalSong: 'أغنية صوتية',
        instrumental: 'موسيقى آلية',
        creativeDescription: 'وصف إبداعي',
        creativeDescriptionPlaceholder: 'صف نمط الموسيقى أو العاطفة أو المشهد المطلوب، على سبيل المثال: موسيقى بوب مريحة مناسبة للتشغيل في مقهى',
        styleCategory: 'النمط',
        moodCategory: 'المزاج',
        instCategory: 'الآلات',
        lyricsContent: 'كلمات الأغنية',
        lyricsPlaceholder: 'اكتب كلمات أغنيتك هنا، يمكنك استخدام علامات [Verse]، [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'أدخل الكلمات...',
        aiGenerate: 'إنشاء بالذكاء الاصطناعي',
        voiceSelect: 'اختيار الصوت',
        selectVoice: 'اختر الصوت',
        voiceTimbre: 'نبرة الصوت',
        maleVoice: 'ذكر',
        femaleVoice: 'أنثى',
        referenceAudioLabel: 'الصوت المرجعي',
        clickToUploadAudio: 'انقر لتحميل الصوت المرجعي (بحد أقصى 5 دقائق)',
        uploading: 'جارٍ التحميل...',
        uploaded: 'تم التحميل',
        pleaseUploadAudioFile: 'يرجى تحميل ملف صوتي',
        audioDurationLimit: 'لا يمكن أن تتجاوز مدة الصوت 5 دقائق',
        cannotReadAudioInfo: 'لا يمكن قراءة معلومات الصوت، يرجى التحقق من تنسيق الملف',
        audioUploadSuccess: 'تم تحميل الصوت بنجاح',
        audioUploadFailed: 'فشل تحميل الصوت',
        pleaseEnterPrompt: 'يرجى إدخال وصف أو كلمات',
        createSuccess: 'تم إرسال مهمة الإنشاء',
        createFailed: 'فشل الإنشاء، يرجى المحاولة مرة أخرى',
        // صفحة MV
        mvDescription: 'أنشئ مرئيات مذهلة بالذكاء الاصطناعي لموسيقاك',
        musicSource: 'مصدر الموسيقى',
        uploadMusic: 'انقر لتحميل ملف الموسيقى',
        visualStyle: 'النمط البصري',
        visualPrompt: 'الوصف البصري',
        visualPromptPlaceholder: 'صف التأثيرات البصرية التي تريدها...',
        resolution: 'الدقة',
        mvEmptyState: 'جاهز لإنشاء MV الخاص بك',
        mvEmptyStateHint: 'حمّل الموسيقى، اختر النمط البصري، ابدأ الإنشاء',
        },
    th: {
        // Music tool component translations
        vocalSong: 'เพลงร้อง',
        instrumental: 'เพลงบรรเลง',
        creativeDescription: 'คำอธิบายเชิงสร้างสรรค์',
        creativeDescriptionPlaceholder: 'อธิบายสไตล์เพลง อารมณ์ หรือฉากที่ต้องการ เช่น ป๊อปผ่อนคลายเหมาะสำหรับเปิดในคาเฟ่',
        styleCategory: 'สไตล์',
        moodCategory: 'อารมณ์',
        instCategory: 'เครื่องดนตรี',
        lyricsContent: 'เนื้อเพลง',
        lyricsPlaceholder: 'เขียนเนื้อเพลงของคุณที่นี่ คุณสามารถใช้แท็ก [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'กรอกเนื้อเพลง...',
        aiGenerate: 'สร้างด้วย AI',
        voiceSelect: 'เลือกเสียง',
        selectVoice: 'เลือกเสียง',
        voiceTimbre: 'โทนเสียง',
        maleVoice: 'ชาย',
        femaleVoice: 'หญิง',
        referenceAudioLabel: 'เสียงอ้างอิง',
        clickToUploadAudio: 'คลิกเพื่ออัปโหลดเสียงอ้างอิง (สูงสุด 5 นาที)',
        uploading: 'กำลังอัปโหลด...',
        uploaded: 'อัปโหลดแล้ว',
        pleaseUploadAudioFile: 'โปรดอัปโหลดไฟล์เสียง',
        audioDurationLimit: 'ความยาวเสียงต้องไม่เกิน 5 นาที',
        cannotReadAudioInfo: 'ไม่สามารถอ่านข้อมูลเสียงได้ โปรดตรวจสอบรูปแบบไฟล์',
        audioUploadSuccess: 'อัปโหลดเสียงสำเร็จ',
        audioUploadFailed: 'อัปโหลดเสียงล้มเหลว',
        pleaseEnterPrompt: 'โปรดกรอกคำอธิบายหรือเนื้อเพลง',
        createSuccess: 'ส่งงานสร้างแล้ว',
        createFailed: 'สร้างไม่สำเร็จ โปรดลองอีกครั้ง',
        // MV page
        mvDescription: 'สร้างภาพ AI สุดตระการตาสำหรับเพลงของคุณ',
        musicSource: 'แหล่งเพลง',
        uploadMusic: 'คลิกเพื่ออัปโหลดไฟล์เพลง',
        visualStyle: 'สไตล์ภาพ',
        visualPrompt: 'คำอธิบายภาพ',
        visualPromptPlaceholder: 'อธิบายเอฟเฟกต์ภาพที่ต้องการ...',
        resolution: 'ความละเอียด',
        mvEmptyState: 'พร้อมสร้าง MV ของคุณแล้ว',
        mvEmptyStateHint: 'อัปโหลดเพลง เลือกสไตล์ภาพ แล้วเริ่มสร้าง',
        },
    da: {
        // Music tool component translations
        vocalSong: 'Vokalsang',
        instrumental: 'Instrumental',
        creativeDescription: 'Kreativ beskrivelse',
        creativeDescriptionPlaceholder: 'Beskriv ønsket musikstil, følelse eller scene, fx afslappende popmusik egnet til en café',
        styleCategory: 'Stil',
        moodCategory: 'Stemning',
        instCategory: 'Instrumenter',
        lyricsContent: 'Sangtekst',
        lyricsPlaceholder: 'Skriv dine lyrics her, du kan bruge [Verse], [Chorus]‑tags...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Indtast lyrics...',
        aiGenerate: 'AI‑generér',
        voiceSelect: 'Stemmesvalg',
        selectVoice: 'Vælg stemme',
        voiceTimbre: 'Stemmeklang',
        maleVoice: 'Mand',
        femaleVoice: 'Kvinde',
        referenceAudioLabel: 'Reference‑audio',
        clickToUploadAudio: 'Klik for at uploade reference‑audio (maks. 5 min)',
        uploading: 'Uploader...',
        uploaded: 'Uploadet',
        pleaseUploadAudioFile: 'Upload venligst en lydfil',
        audioDurationLimit: 'Lydens varighed må ikke overstige 5 minutter',
        cannotReadAudioInfo: 'Kan ikke læse lydinfo, tjek filformatet',
        audioUploadSuccess: 'Lyd uploadet',
        audioUploadFailed: 'Lyd upload mislykkedes',
        pleaseEnterPrompt: 'Indtast en beskrivelse eller lyrics',
        createSuccess: 'Opgave sendt',
        createFailed: 'Oprettelse mislykkedes, prøv igen',
        // MV page
        mvDescription: 'Skab imponerende AI‑visuals til din musik',
        musicSource: 'Musikkilde',
        uploadMusic: 'Klik for at uploade musikfil',
        visualStyle: 'Visuel stil',
        visualPrompt: 'Visuel beskrivelse',
        visualPromptPlaceholder: 'Beskriv de visuelle effekter, du ønsker...',
        resolution: 'Opløsning',
        mvEmptyState: 'Klar til at lave din MV',
        mvEmptyStateHint: 'Upload musik, vælg visuel stil, og start genereringen',
        },
    no: {
        // Music tool component translations
        vocalSong: 'Vokalsang',
        instrumental: 'Instrumental',
        creativeDescription: 'Kreativ beskrivelse',
        creativeDescriptionPlaceholder: 'Beskriv ønsket musikkstil, følelse eller scene, f.eks. avslappende popmusikk for en kafé',
        styleCategory: 'Stil',
        moodCategory: 'Stemning',
        instCategory: 'Instrumenter',
        lyricsContent: 'Tekst',
        lyricsPlaceholder: 'Skriv teksten her, du kan bruke [Verse], [Chorus]-tagger...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Skriv inn tekst...',
        aiGenerate: 'AI‑generer',
        voiceSelect: 'Stemmevalg',
        selectVoice: 'Velg stemme',
        voiceTimbre: 'Stemmeklang',
        maleVoice: 'Mann',
        femaleVoice: 'Kvinne',
        referenceAudioLabel: 'Referanselyd',
        clickToUploadAudio: 'Klikk for å laste opp referanselyd (maks 5 minutter)',
        uploading: 'Laster opp...',
        uploaded: 'Lastet opp',
        pleaseUploadAudioFile: 'Vennligst last opp en lydfil',
        audioDurationLimit: 'Lydlengden kan ikke overstige 5 minutter',
        cannotReadAudioInfo: 'Kan ikke lese lydinformasjon, sjekk filformatet',
        audioUploadSuccess: 'Lyd lastet opp',
        audioUploadFailed: 'Lydopplasting mislyktes',
        pleaseEnterPrompt: 'Skriv inn en beskrivelse eller tekst',
        createSuccess: 'Oppgave sendt',
        createFailed: 'Oppretting mislyktes, prøv igjen',
        // MV page
        mvDescription: 'Lag imponerende AI‑visuals til musikken din',
        musicSource: 'Musikkilde',
        uploadMusic: 'Klikk for å laste opp musikkfil',
        visualStyle: 'Visuell stil',
        visualPrompt: 'Visuell beskrivelse',
        visualPromptPlaceholder: 'Beskriv de visuelle effektene du ønsker...',
        resolution: 'Oppløsning',
        mvEmptyState: 'Klar til å lage din MV',
        mvEmptyStateHint: 'Last opp musikk, velg visuell stil, og start generering',
        },
    nl: {
        // Music tool component translations
        vocalSong: 'Zangnummer',
        instrumental: 'Instrumentaal',
        creativeDescription: 'Creatieve beschrijving',
        creativeDescriptionPlaceholder: 'Beschrijf de gewenste muziekstijl, emotie of scène, bijv. ontspannen popmuziek voor een café',
        styleCategory: 'Stijl',
        moodCategory: 'Mood',
        instCategory: 'Instrumenten',
        lyricsContent: 'Songtekst',
        lyricsPlaceholder: 'Schrijf je songtekst hier, je kunt [Verse], [Chorus]‑tags gebruiken...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Voer songtekst in...',
        aiGenerate: 'AI genereren',
        voiceSelect: 'Stemselectie',
        selectVoice: 'Selecteer stem',
        voiceTimbre: 'Stemkleur',
        maleVoice: 'Man',
        femaleVoice: 'Vrouw',
        referenceAudioLabel: 'Referentie‑audio',
        clickToUploadAudio: 'Klik om referentie‑audio te uploaden (max. 5 minuten)',
        uploading: 'Bezig met uploaden...',
        uploaded: 'Geüpload',
        pleaseUploadAudioFile: 'Upload een audiobestand',
        audioDurationLimit: 'Audio mag niet langer zijn dan 5 minuten',
        cannotReadAudioInfo: 'Kan audio‑info niet lezen, controleer het bestandsformaat',
        audioUploadSuccess: 'Audio succesvol geüpload',
        audioUploadFailed: 'Audio upload mislukt',
        pleaseEnterPrompt: 'Voer een beschrijving of songtekst in',
        createSuccess: 'Creatietaak ingediend',
        createFailed: 'Creatie mislukt, probeer opnieuw',
        // MV page
        mvDescription: 'Maak verbluffende AI‑visuals voor je muziek',
        musicSource: 'Muziekbron',
        uploadMusic: 'Klik om een muziekbestand te uploaden',
        visualStyle: 'Visuele stijl',
        visualPrompt: 'Visuele beschrijving',
        visualPromptPlaceholder: 'Beschrijf de visuele effecten die je wilt...',
        resolution: 'Resolutie',
        mvEmptyState: 'Klaar om je MV te maken',
        mvEmptyStateHint: 'Upload muziek, kies visuele stijl en start met genereren',
        },
    id: {
        // Music tool component translations
        vocalSong: 'Lagu vokal',
        instrumental: 'Instrumental',
        creativeDescription: 'Deskripsi kreatif',
        creativeDescriptionPlaceholder: 'Jelaskan gaya musik, emosi, atau suasana yang diinginkan, misalnya pop santai untuk diputar di kafe',
        styleCategory: 'Gaya',
        moodCategory: 'Mood',
        instCategory: 'Instrumen',
        lyricsContent: 'Lirik',
        lyricsPlaceholder: 'Tulis lirik Anda di sini, Anda bisa menggunakan tag [Verse], [Chorus]...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Masukkan lirik...',
        aiGenerate: 'Buat dengan AI',
        voiceSelect: 'Pilih suara',
        selectVoice: 'Pilih suara',
        voiceTimbre: 'Timbre suara',
        maleVoice: 'Pria',
        femaleVoice: 'Wanita',
        referenceAudioLabel: 'Audio referensi',
        clickToUploadAudio: 'Klik untuk mengunggah audio referensi (maks. 5 menit)',
        uploading: 'Mengunggah...',
        uploaded: 'Diunggah',
        pleaseUploadAudioFile: 'Silakan unggah file audio',
        audioDurationLimit: 'Durasi audio tidak boleh melebihi 5 menit',
        cannotReadAudioInfo: 'Tidak dapat membaca info audio, periksa format file',
        audioUploadSuccess: 'Audio berhasil diunggah',
        audioUploadFailed: 'Gagal mengunggah audio',
        pleaseEnterPrompt: 'Masukkan deskripsi atau lirik',
        createSuccess: 'Tugas pembuatan dikirim',
        createFailed: 'Pembuatan gagal, silakan coba lagi',
        // MV page
        mvDescription: 'Buat visual AI yang menakjubkan untuk musik Anda',
        musicSource: 'Sumber musik',
        uploadMusic: 'Klik untuk mengunggah file musik',
        visualStyle: 'Gaya visual',
        visualPrompt: 'Deskripsi visual',
        visualPromptPlaceholder: 'Jelaskan efek visual yang Anda inginkan...',
        resolution: 'Resolusi',
        mvEmptyState: 'Siap membuat MV Anda',
        mvEmptyStateHint: 'Unggah musik, pilih gaya visual, lalu mulai membuat',
        },
    tr: {
        // Music tool component translations
        vocalSong: 'Vokalli şarkı',
        instrumental: 'Enstrümantal',
        creativeDescription: 'Yaratıcı açıklama',
        creativeDescriptionPlaceholder: 'İstediğiniz müzik stilini, duyguyu veya sahneyi açıklayın; örn. kafede çalınmaya uygun rahatlatıcı pop',
        styleCategory: 'Stil',
        moodCategory: 'Mood',
        instCategory: 'Enstrümanlar',
        lyricsContent: 'Şarkı sözleri',
        lyricsPlaceholder: 'Şarkı sözlerinizi buraya yazın, [Verse], [Chorus] etiketlerini kullanabilirsiniz...',
        lyricsVerse: '[Verse]',
        lyricsChorus: '[Chorus]',
        enterLyrics: 'Sözleri girin...',
        aiGenerate: 'AI ile üret',
        voiceSelect: 'Ses seçimi',
        selectVoice: 'Ses seç',
        voiceTimbre: 'Ses tınısı',
        maleVoice: 'Erkek',
        femaleVoice: 'Kadın',
        referenceAudioLabel: 'Referans ses',
        clickToUploadAudio: 'Referans ses yüklemek için tıklayın (maks. 5 dakika)',
        uploading: 'Yükleniyor...',
        uploaded: 'Yüklendi',
        pleaseUploadAudioFile: 'Lütfen bir ses dosyası yükleyin',
        audioDurationLimit: 'Ses süresi 5 dakikayı aşamaz',
        cannotReadAudioInfo: 'Ses bilgisi okunamadı, dosya formatını kontrol edin',
        audioUploadSuccess: 'Ses başarıyla yüklendi',
        audioUploadFailed: 'Ses yükleme başarısız',
        pleaseEnterPrompt: 'Lütfen bir açıklama veya söz girin',
        createSuccess: 'Oluşturma görevi gönderildi',
        createFailed: 'Oluşturma başarısız, lütfen tekrar deneyin',
        // MV page
        mvDescription: 'Müziğiniz için etkileyici AI görselleri oluşturun',
        musicSource: 'Müzik kaynağı',
        uploadMusic: 'Müzik dosyası yüklemek için tıklayın',
        visualStyle: 'Görsel stil',
        visualPrompt: 'Görsel açıklama',
        visualPromptPlaceholder: 'İstediğiniz görsel efektleri açıklayın...',
        resolution: 'Çözünürlük',
        mvEmptyState: 'MV’nizi oluşturmak için hazır',
        mvEmptyStateHint: 'Müzik yükleyin, görsel stil seçin, üretmeye başlayın',
    },
}
